import { onBeforeUnmount,onMounted,ref } from 'vue';

/** Fetch/render previews only as they approach the viewport. */
export function useVisiblePreview(){
  const element=ref<HTMLElement|null>(null);const visible=ref(false);
  let observer:IntersectionObserver|undefined;
  onMounted(()=>{
    if(typeof IntersectionObserver==='undefined'||!element.value){visible.value=true;return;}
    observer=new IntersectionObserver(entries=>{
      if(entries.some(entry=>entry.isIntersecting)){visible.value=true;observer?.disconnect();}
    },{rootMargin:'160px'});
    observer.observe(element.value);
  });
  onBeforeUnmount(()=>observer?.disconnect());
  return {element,visible};
}
